import 'ant-design-vue/dist/antd.min.css';
import 'element-plus/dist/index.css';

import '@kunlun/vue-ui-antd/dist/kunlun-vue-ui-antd.css';
import '@kunlun/vue-ui-el/dist/kunlun-vue-ui-el.css';

import 'reflect-metadata';
import {
  Dialog,
  IResponseErrorResult,
  MessageHub,
  OioLoginLogoPosition,
  OioLoginThemeName,
  registerMask,
  registerTheme,
  ReturnPromise,
  RuntimeContextManager,
  VueOioProvider
} from '@kunlun/dependencies';


import './mask';
import './field';
import './view';
import './views';
import './actions';

import './util/common.scss';
import { themeCssVars, themeName } from './theme';
import { App } from 'vue';

registerTheme(themeName, themeCssVars);

// <widget widget="language" />
// <widget widget="divider" />

// <widget widget="MobileMall" />
// <widget widget="divider" />
// <widget widget="PCMall" />
// <widget widget="divider" />

registerMask(
  `
    <mask>
      <header>
        <widget widget="app-switcher" />
        <block>
          <widget widget="notification" />
          <widget widget="divider" />
          <widget widget="merchantUser" />
          <widget widget="divider" />
          <widget widget="user" />
        </block>
      </header>
      <container>
        <sidebar>
          <widget widget="nav-menu" height="100%" />
        </sidebar>
        <block height="100%" flex="1 0 0" flexDirection="column" alignContent="flex-start" flexWrap="nowrap" overflow="hidden">
          <multi-tabs inline="true" />
          <content>
            <breadcrumb />
            <block width="100%">
              <widget width="100%" widget="main-view" />
            </block>
          </content>
        </block>
      </container>
    </mask>
  `
);

VueOioProvider({
  http: {
    encodeRsql: true,
    url: location.origin,
    // callback: interceptor
    interceptor: {
      networkError: {
        error(response: IResponseErrorResult): ReturnPromise<boolean> {
          const { networkError, errors } = response;
          const errorCode = errors?.[0]?.extensions?.errorCode;

          const CHANGE_PWD_ERRORCODE = '50070065';
          if (errorCode == CHANGE_PWD_ERRORCODE) {
            location.href = '/first';
            return false;
          }

          if (networkError) {
            const { bodyText, name, message } = networkError;
            if (name && message) {
              if (!/Time\-out|timeout/i.test(bodyText)) {
                MessageHub.error(message);
              } else {
                Dialog.dispose();
              }
            }
            return false;
          }
          return true;
        }
      },
      requestError: {
        error(response: IResponseErrorResult): ReturnPromise<boolean> {
          const { errors } = response;
          if (errors?.length) {
            if (errors[0]?.message?.includes('ariesActivityItemTplDetailQuery/formTableImportWidgetV2Validate')) {
              MessageHub.error('excel数据格式错误，请检查excel数据。');
              return true;
            }
            MessageHub.error(errors[0].message || errors[0]?.extensions?.messages?.[0]?.message);
          }
          return true;
        }
      }
    }
  },
  browser: {
    title: 'dms'
    // favicon: 'https://fxit-dhb-tjb.oss-cn-hangzhou.aliyuncs.com/deli-b2b/image/favicon.jpg'
  },
  theme: [themeName],
  loginTheme: {
    backgroundImage: '',
    backgroundColor: '#f5f5f5',
    logoPosition: OioLoginLogoPosition.CENTER,
    name: OioLoginThemeName.CENTER_STICK
  },
  dependencies: {
    vue: import('vue'),
    lodashEs: import('lodash-es'),
    antDesignVue: import('ant-design-vue'),
    elementPlusIconsVue: import('@element-plus/icons-vue'),
    elementPlus: import('element-plus'),
    kunlunDependencies: import('@kunlun/dependencies'),
    kunlunVueUiAntd: import('@kunlun/vue-ui-antd'),
    kunlunVueUiEl: import('@kunlun/vue-ui-el'),
    kunlunDataDesignerCore: import('@kunlun/data-designer-core'),
    antvDataSet: import('@antv/data-set'),
    antvG2: import('@antv/g2'),
    echarts: import('echarts'),
    xlsx: import('xlsx'),
    fileSaver: import('file-saver'),
    Decimal: import('decimal.js'),
    JSZip: import('jszip')
  }
},[
    () => {
        // 页面加载完成后初始化水印功能
        window.addEventListener('load', function() {
            addWatermark();
        });

        // 监听路由变化，只在主路由变化时重新添加水印
        let lastMainPath = window.location.pathname.startsWith('/login') ? '/login' : '/page';
        const observer = new MutationObserver(function() {
            // 判断当前主路由
            const currentMainPath = window.location.pathname.startsWith('/login') ? '/login' : '/page';
            
            // 只有当主路由发生变化时才重新添加水印
            if (currentMainPath !== lastMainPath) {
                lastMainPath = currentMainPath;
                addWatermark();
            }
        });

        observer.observe(document, { subtree: true, childList: true });

        // 初始加载时也添加一次水印
        addWatermark();
    }
]);

// 将水印逻辑提取为独立函数，便于重复调用
function addWatermark() {
    // 如果是登录页面，则不添加水印
    if (window.location.pathname.startsWith('/login')) {
        // 移除已存在的水印
        const existingWatermarks = document.querySelectorAll('.mask_div');
        existingWatermarks.forEach(el => el.remove());
        console.info('login登录页，不添加水印');
        return;
    }

    // 获取当前日期
    const currentDate = new Date();
    // 提取年、月、日
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
    const day = String(currentDate.getDate()).padStart(2, '0'); // 确保日期为两位数
    // 格式化为 YYYY/MM/DD
    const formattedDate = year + '/' + month + '/' + day;

    // 从DOM中获取用户名
    let username = 'dms';
    
    // 延时执行，等待页面渲染完成
    setTimeout(() => {
        // 先移除已存在的水印
        const existingWatermarks = document.querySelectorAll('.mask_div');
        existingWatermarks.forEach(el => el.remove());
        
        const userElement = document.querySelector('.k-user.ant-dropdown-trigger');
        console.info('获取用户元素:', userElement);
        if (userElement) {
            // 获取span元素
            const spanElements = userElement.querySelectorAll('span');
            console.info('找到的span元素:', spanElements);
            if (spanElements.length >= 2) {
                username = spanElements[0].textContent?.trim() || 'dms0';
            } else if (spanElements.length === 1) {
                username = spanElements[0].textContent?.trim() || 'dms1';
            }
            console.info('获取到的用户名:', username);
        }
        
        // 生成水印文本并调用水印函数
        var watermarkText = username + '@' + '齐心集团股份有限公司' + formattedDate;
        watermark({ "watermark_txt": watermarkText });
    }, 4000); // 延时1秒
}

function watermark(settings) {
    //默认设置
    var defaultSettings = {
        watermark_txt: "",
        watermark_x: 20, //水印起始位置x轴坐标
        watermark_y: 20, //水印起始位置Y轴坐标
        watermark_rows: 0, //水印行数
        watermark_cols: 999, //水印列数
        watermark_x_space: 10, //水印x轴间隔
        watermark_y_space: 50, //水印y轴间隔
        watermark_color: '#aaa', //水印字体颜色
        watermark_alpha: '0.3', //水印透明度
        watermark_fontsize: '12px', //水印字体大小
        watermark_font: '微软雅黑', //水印字体
        watermark_width: 230, //水印宽度
        watermark_height: 80, //水印长度
        watermark_angle: 20 //水印倾斜度数
    };
    // 使用原生 JavaScript 实现：
    Object.assign(defaultSettings, settings === undefined ? {} : settings);
    let newText = "";
    for (let i = 0; i < defaultSettings.watermark_txt.length; i++) {
        if (i % 2 !== 0) {
            newText += " ";
        }
        newText += defaultSettings.watermark_txt[i];
    }
    defaultSettings.watermark_txt = newText;
    //根据函数的入参调整设置
    if (arguments.length === 1 && typeof arguments[0] === "object") {
        var src = arguments[0] || {};
        for (let key in src) {  // 修复：添加变量声明
            if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) continue;
            else if (src[key]) defaultSettings[key] = src[key];
        }
    }
    //创建虚拟节点对象，在该节点对象中可以放元素，最后只需在页面中添加该节点对象即可。可提高性能
    var oTemp = document.createDocumentFragment();
    //获取页面最大宽度
    var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
    var cutWidth = page_width * 0.0150;
    var page_width = page_width - cutWidth;
    //获取页面最大高度


    //var page_height = document.body.scrollHeight + document.body.clientHeight;
    var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight) + 450;
    page_height = Math.max(page_height, window.innerHeight - 30);
    // 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_cols == 0 || (Math.floor(defaultSettings.watermark_x + defaultSettings
        .watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (
        defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = Math.floor((page_width - defaultSettings.watermark_x + defaultSettings
            .watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = Math.floor((page_width - defaultSettings.watermark_x - defaultSettings
            .watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
    }
// 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_rows == 0 || (Math.floor(defaultSettings.watermark_y + defaultSettings
        .watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (
        defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = Math.floor((defaultSettings.watermark_y_space + page_height - defaultSettings
            .watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = Math.floor(((page_height - defaultSettings.watermark_y) - defaultSettings
            .watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
    }
    var x;
    var y;
    for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
            x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) *
                j;
            // 在水印函数中找到创建 mask_div 的部分，添加以下样式
            var mask_div = document.createElement('div');
            mask_div.id = 'mask_div' + i + j;
            mask_div.className = 'mask_div';
            mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));

// 设置水印div倾斜显示
            mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            (mask_div.style as any).MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            (mask_div.style as any).msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            (mask_div.style as any).OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
            mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";

// 添加这些关键样式来避免影响页面布局
            //mask_div.style.visibility = "hidden"; // 初始隐藏
            mask_div.style.position = "fixed"; // 使用 fixed 定位而不是 absolute
            mask_div.style.left = x + 'px';
            mask_div.style.top = y + 'px';
            mask_div.style.overflow = "hidden";
            mask_div.style.zIndex = "9999";
            mask_div.style.pointerEvents = 'none';
            mask_div.style.opacity = defaultSettings.watermark_alpha;
            mask_div.style.fontSize = defaultSettings.watermark_fontsize;
            mask_div.style.fontFamily = defaultSettings.watermark_font;
            mask_div.style.color = defaultSettings.watermark_color;
            mask_div.style.textAlign = "center";
            mask_div.style.width = defaultSettings.watermark_width + 'px';
            mask_div.style.height = defaultSettings.watermark_height + 'px';
            mask_div.style.display = "block";

// 确保水印不影响页面布局
            mask_div.style.margin = "0";
            mask_div.style.padding = "0";
            mask_div.style.border = "0";
            mask_div.style.boxSizing = "border-box";

            oTemp.appendChild(mask_div);

        }
    }
    //document.body.appendChild(oTemp);
    //$("#pdfContainer").append(oTemp);
    //$('.tab-content').append(oTemp); //
    document.body.appendChild(oTemp);

}